<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <!--page content-->
            <div class="admin-page-content">
                <div class="page-title-container">
                    <div class="page-name">{{pageTitle}}</div>
                    <!-- <button v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button> -->
                    <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                </div>
                <!--Forms-->
                <div class="forms-container default-bx-shadow responsive-forms-container">
                    <div class="row no-margin">     
                        <template v-if="loginUserRoleId == 1 || loginUserRoleId == 2">
                            <!-- Return Order -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">PAR Claim# :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="returnOrderError = ''" maxlength="190" class="form-control" v-model="returnOrder" id="returnOrder" placeholder="Enter PAR Claim" name="returnOrder">
                                    <!-- <div class="help is-danger">{{returnOrderError}}</div>
                                    <div class="requiredstar">*</div> -->
                                </div>
                            </div>
                            <!-- Credit PO -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Credit PO# :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="creditPOError = ''" maxlength="190" class="form-control" v-model="creditPO" id="creditPO" placeholder="Enter Credit PO" name="creditPO">
                                    <!-- <div class="help is-danger">{{creditPOError}}</div>
                                    <div class="requiredstar">*</div> -->
                                </div>
                            </div>
                            <!-- Claim -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Claim Status :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input type="text" @input="claimError = ''" maxlength="190" class="form-control" v-model="claim" id="claim" placeholder="Enter Claim Status" name="claim">
                                    <!-- <div class="help is-danger">{{claimError}}</div>
                                    <div class="requiredstar">*</div> -->
                                </div>
                            </div>
                        </template>
                        <!-- By -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">By :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="byError = ''" maxlength="190" class="form-control" v-model="by" id="by" placeholder="Enter By" name="by">
                                <div class="help is-danger">{{byError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Date -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Date :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <date-picker @input="dateError = ''" placeholder="MM/DD/YYYY" id="date_of_request" name="date" v-model="date" :config="options" aria-describedby="basic-addon1"></date-picker>
                                <div class="help is-danger">{{dateError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- PAR Tag -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">PAR Tag# :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="parTagError = ''" maxlength="190" class="form-control" v-model="parTag" id="parTag" placeholder="Enter PAR Tag" name="parTag">
                                <!-- <div class="help is-danger">{{parTagError}}</div>
                                <div class="requiredstar">*</div> -->
                            </div>
                        </div>
                        <!-- PO -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">PO# :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="poError = ''" maxlength="190" class="form-control" v-model="po" id="po" placeholder="Enter PO" name="po">
                                <!-- <div class="help is-danger">{{poError}}</div>
                                <div class="requiredstar">*</div> -->
                            </div>
                        </div>
                        <!-- Daimler Invoice -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Daimler Invoice# :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="daimlerInvoiceError = ''" maxlength="190" class="form-control" v-model="daimlerInvoice" id="daimlerInvoice" placeholder="Enter Daimler Invoice" name="daimlerInvoice">
                                <!-- <div class="help is-danger">{{daimlerInvoiceError}}</div>
                                <div class="requiredstar">*</div> -->
                            </div>
                        </div>
                        <!-- Customer Invoice Credit# -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Customer Invoice Credit# :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="customerInvoiceCreditError = ''" maxlength="190" class="form-control" v-model="customerInvoiceCredit" id="customerInvoiceCredit" placeholder="Enter Customer Invoice Credit" name="customerInvoiceCredit">
                                <div class="help is-danger">{{customerInvoiceCreditError}}</div>
                                <!-- <div class="requiredstar">*</div> -->
                            </div>
                        </div>
                        <!-- Daimler Invoice -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Restocking fee :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input type="text" @input="restockingFeeError = ''" maxlength="190" class="form-control" v-model="restockingFee" id="restockingFee" placeholder="Enter Restocking Fee" name="restockingFee">
                                <div class="help is-danger">{{restockingFeeError}}</div>
                                <!-- <div class="requiredstar">*</div> -->
                            </div>
                        </div>
                        <!-- Location -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Location :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="location" name="location"
                                    label="name" placeholder="Select Location"
                                    @input="locationError = ''"
                                    :options="location_arr" :clearable=false>
                                </v-select>
                                <div class="help is-danger">{{locationError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <div class="col-12 forms-block">
                            <ul>
                                <li>
                                    Please make sure part meets $50 minimum . Part must be credited or removed from Front/Back counter ticket before being submitted to PAR.
                                </li>
                            </ul>
                        </div>
                        <template v-for="(partMap, index) in partsArr">
                            <div :key="'Part ' + index" class="col-3 forms-block">
                                <div class="">
                                    <div class="form-label">Part# :</div>
                                </div>
                                <div class="requied-par-request">
                                    <input type="text" @input="partMap.partError = ''" maxlength="190" class="form-control" v-model="partMap.part" id="part" name="part">
                                    <div class="help is-danger">{{partMap.partError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <div :key="'Quantity ' + index" class="col-2 forms-block">
                                <div class="">
                                    <div class="form-label">Quantity :</div>
                                </div>
                                <div class="requied-par-request">
                                    <input type="text" @input="partMap.quantityError = ''" maxlength="190" class="form-control" v-model="partMap.quantity" id="quantity" name="quantity">
                                    <div class="help is-danger">{{partMap.quantityError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <div :key="'Description ' + index" class="col-6 forms-block">
                                <div class="">
                                    <div class="form-label">Description :</div>
                                </div>
                                <div class="requied-par-request">
                                    <textarea @input="partMap.descriptionError = ''" class="form-control" v-model="partMap.description" id="description" name="description"></textarea>
                                    <div class="help is-danger">{{partMap.descriptionError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <template v-if="partsArr.length == (index + 1) && plusCount != 0">
                                    <div :key="'plus ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                        <button type="button" v-on:click="addNewDocument(partMap, index)" class="btn btn-success">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                                <template v-else>
                                    <div :key="'close ' + index" style="margin-top: 28px;" class="col-1 forms-block">
                                        <button type="button" v-on:click="removePartDocument(partMap, index)" class="btn btn-danger">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                        </template>
                        <!-- Reason for Return -->
                        <div class="col-12 forms-block">
                            <div class="">
                                <div class="form-label">Reason for Return :</div>
                            </div>
                            <div class="col-12 paddingleft0">
                                <textarea @input="reasonForReturnError = ''" class="form-control" v-model="reasonForReturn" id="reasonForReturn" placeholder="Enter Reason for Return" name="reasonForReturn"></textarea>
                                <div class="help is-danger">{{reasonForReturnError}}</div>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <!-- Customer Order Error -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="customerOrderError">Customer Order Error</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="customerOrderError" v-model="customerOrderError" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Boxed Wrong -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="boxedWrong">Boxed Wrong</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="boxedWrong" v-model="boxedWrong" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Damage/Pkg Related -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="damageAndPakageRelated">Damage/Pkg Related</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="damageAndPakageRelated" v-model="damageAndPakageRelated" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Ship Short -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="shipShort">Ship Short</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="shipShort" v-model="shipShort" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Defect. Not Damage -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="defectNotDamage">Defect. Not Damage</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="defectNotDamage" v-model="defectNotDamage" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Duplicate Invoice -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="duplicateInvoice">Duplicate Invoice</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="duplicateInvoice" v-model="duplicateInvoice" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Return to Vendor -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="returnToVendor">Return to Vendor</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="returnToVendor" v-model="returnToVendor" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Freight Adjustment/Claim -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="freightAdjustmentAndClaim">Freight Adjustment/Claim</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="freightAdjustmentAndClaim" v-model="freightAdjustmentAndClaim" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Wrong Part Received -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="wrongPartReceived">Wrong Part Received</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="wrongPartReceived" v-model="wrongPartReceived" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Billing Adjustment -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="billingAdjustment">Billing Adjustment</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="billingAdjustment" v-model="billingAdjustment" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Overage -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="overage">Overage</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="overage" v-model="overage" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Incorrect Dealer Invoiced -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="incorrectDealerInvoiced">Incorrect Dealer Invoiced</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="incorrectDealerInvoiced" v-model="incorrectDealerInvoiced" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Shipped to Wrong Dealer -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="shippedToWrongDealer">Shipped to Wrong Dealer</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="shippedToWrongDealer" v-model="shippedToWrongDealer" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Special & Labor Charge -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="specialAndLaborCharge">Special & Labor Charge</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="specialAndLaborCharge" v-model="specialAndLaborCharge" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Freight Claims -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="freightClaims">Freight Claims</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="freightClaims" v-model="freightClaims" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Policy Adjustment -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="policyAdjustment">Policy Adjustment</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="policyAdjustment" v-model="policyAdjustment" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Corp Rtrn/Superseded Part -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="corpReturnSupersededPart">Corp Rtrn/Superseded Part</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="corpReturnSupersededPart" v-model="corpReturnSupersededPart" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Incorrect Price -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="incorrectPrice">Incorrect Price</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="incorrectPrice" v-model="incorrectPrice" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <!-- Recall/Srvc Return -->
                        <div class="col-4">
                            <div class="row">
                                <div class="col-5">
                                    <label style="padding-top: 5px;" for="recallAndServiceReturn">Recall/Srvc Return</label>
                                </div>
                                <div class="col-7">
                                    <label style="text-align: left;" class="">
                                        <input style="width: 24px;" id="recallAndServiceReturn" v-model="recallAndServiceReturn" class="form-control" type="checkbox"/>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 forms-block">
                            <div class="col-12 paddingleft0">
                                <div class="form-label block-title-par-request">LOCATION OF PART(S)</div>
                            </div>
                        </div>
                        <!-- Dealer PAR Warehouse Location -->
                        <div class="col-6 forms-block">
                            <div class="">
                                <label class="">
                                    <input style="width: 24px;" id="dealerPARWarehouseLocation" v-model="dealerPARWarehouseLocation" class="form-control" type="checkbox"/>
                                </label>
                                <label style="vertical-align: top; padding-top: 5px; margin-left: 10px;" for="dealerPARWarehouseLocation">Dealer PAR Warehouse Location</label>
                            </div>
                        </div>
                        <!-- Other -->
                        <div class="col-6 forms-block">
                            <div class="row">
                                <div class="col-2">
                                    <label class="">
                                        <input style="width: 24px;" id="other" v-model="other" class="form-control" type="checkbox"/>
                                    </label>
                                    <label style="vertical-align: top; padding-top: 5px; margin-left: 10px;" for="other">Other</label>
                                </div>
                                <div class="col-10">
                                    <template v-if="other">
                                        <input type="text" @input="otherTextError = ''" maxlength="190" class="form-control" v-model="otherText" id="otherText" placeholder="" name="otherText">
                                        <div class="help is-danger">{{otherTextError}}</div>
                                        <div class="requiredstar">*</div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 forms-block">
                            <div class="">
                                <div class="form-label">Upload Document :</div>
                            </div>
                            <div class="col-12 paddingleft0">
                                <vue-dropzone
                                    id="drop1"
                                    :options="dropzoneOptions"
                                    ref="dropzone"
                                    :destroyDropzone="false"
                                    @vdropzone-removed-file="removedSelectedFile"
                                    @vdropzone-success="uploadDocument"
                                    @vdropzone-error="fileError"
                                    @vdropzone-file-added="fileAdd"
                                    @vdropzone-total-upload-progress="progressOfUloadBanner"
                                    name="file"
                                    :useCustomSlot=true
                                    >
                                    <div class="dropzone-custom-content">
                                        <h4 class="dropzone-custom-title">Drop files here or click to upload.</h4>
                                        <div class="subtitle">(Select files from your computer.)</div>
                                    </div>
                                </vue-dropzone>
                                <div class="requiredstar">*</div>
                                <span class="help is-danger">{{fileUploadError}}</span>
                            </div>
                        </div>
                        <div class="col-12 forms-block">
                            <ul>
                                <li>
                                    Damages From Carrier(Freight Claim): 3 pictures and copy of BOL with note of shortage or damage (1st picture 4 ft away 2nd picture close up of damages 3rd picture of PDC tag/ sticker on the box).
                                </li>
                                <li>
                                    Damages Packaging Related: 2 pictures (1st picture of condition part arrived 2nd picture of the PDC tag/sticker on the part).
                                </li>
                                <li>
                                    Overages/Shortages: 1 picture of PDC tag/sticker on the affected part. Boxed Wrong or Defective: 3 pictures (1st picture of PDC tag/sticker on the package/part, 2nd picture of what was received or the defective area).
                                </li>
                            </ul>
                        </div>
                        <div class="clearfix"></div>
                        <div class="mr-17 pb-12 float-l">
                            <!-- <button id="cancelPARRequest" v-if="loginUserRoleId == 1 || loginUserRoleId == 2" type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button> -->
                            <button id="cancelPARRequest" type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                            <button id="savePARRequest" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addPARRequest('save')"><span id="createAttachment">{{buttonNames.save}}</span></button>
                        </div>
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPGUZZLE} from '../../../http-common.js';
    import {commonMixins} from '../../../mixins/commonMixins';
    import EventBus from "../../../components/event-bus";

    var self;
    Vue.component('v-select', vSelect)
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdatePARRequest',
        mixins: [commonMixins],
        data() {
            return {
                // user_role: 0,
                pageTitle: 'PAR Request',
                edit_id: 0,
                returnOrder: "",
                returnOrderError: "",
                creditPO: "",
                creditPOError: "",
                claim: "",
                claimError: "",
                by: "",
                byError: "",
                date: new Date(),
                dateError: "",
                options: {
                    format: 'MM/DD/YYYY',
                },
                parTag: "",
                parTagError: "",
                po: "",
                poError: "",
                daimlerInvoice: "",
                daimlerInvoiceError: "",
                customerInvoiceCredit: "",
                customerInvoiceCreditError: "",
                restockingFee: "",
                restockingFeeError: "",
                location: "",
                location_arr: [],
                locationError: "",
                reasonForReturn: "",
                reasonForReturnError: "",
                customerOrderError: 0,
                boxedWrong: 0,
                damageAndPakageRelated: 0,
                shipShort: 0,
                defectNotDamage: 0,
                duplicateInvoice: 0,
                returnToVendor: 0,
                freightAdjustmentAndClaim: 0,
                wrongPartReceived: 0,
                billingAdjustment: 0,
                overage: 0,
                incorrectDealerInvoiced: 0,
                shippedToWrongDealer: 0,
                specialAndLaborCharge: 0,
                freightClaims: 0,
                policyAdjustment: 0,
                corpReturnSupersededPart: 0,
                incorrectPrice: 0,
                recallAndServiceReturn: 0,
                dealerPARWarehouseLocation: 0,
                other: 0,
                otherText: "",
                otherTextError: "",
                managerEmail: "",
                managerName: "",
                loginUserRoleId: 1,

                partsArr: [
                    {
                        part: "",
                        partError: "",
                        quantity: "",
                        quantityError: "",
                        description: "",
                        descriptionError: "",
                    }
                ],
                tempObject: {
                    part: "",
                    partError: "",
                    quantity: "",
                    quantityError: "",
                    description: "",
                    descriptionError: "",
                },
                plusCount: 9,
                //DropZone
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/store_document",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 5, //MB
                    maxFiles: 10, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    acceptedFiles: ".jpg, .jpeg, .png, .pdf, .doc, .docx, .xlsx, .xls, .csv, .zip, .ppt, .pptx, .gif",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("tkn"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dictFileTooBig: "File is to big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only {{maxFiles}} file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },
                imagesPaths: [],
                imagesType: [],
                imagesSize: [],
                loadDocArr: [],
                imageWidth: 0,
                imageHeight: 0,
                isFileUploaded: false,
                fileUploadError : "",
                buttonNames: {
                    save: 'Save'
                }
            }
        },
        watch: {
            location: function(location) {
                self.managerEmail = "";
                self.managerName = "";
                if (location != null || location.id) {
                    for(var index = 0;index<self.location_arr.length;index++) {
                        var obj = self.location_arr[index];
                        if(obj['id'] == location.id) {
                            self.managerEmail = obj['manager_email'];
                            if(obj['manager_name'] != '' && obj['manager_name'] != null) {
                                self.managerName = obj['manager_name'];
                            }
                        }
                    }
                }
            },
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.menuActive("PARRequest");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUserRoleId = userJson['role'].system_id;
            }
            self.loadLocation();
            self.mobileResizeViewAddUpdateSupportStaggPage();
            window.onresize = function() {
                self.mobileResizeViewAddUpdateSupportStaggPage();
            }
            if (typeof(self.$route.params.id)  != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                self.edit_id = self.$route.params.id;
                self.getPARRequestById();
                self.buttonNames.save = "Update";
                self.pageTitle = "Edit PAR Request";
            }
        },
        methods: {
            buttonBack() {
                self.$router.push('/par/request/list');
            },
            mobileResizeViewAddUpdateSupportStaggPage: function() {
                var self = this;
                if (window.innerWidth < 766) {
                    self.mobileView = true;
                } else {
                    self.mobileView = false;
                }
            },
            getPARRequestById: function() {
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("tkn")
                    },
                    params : {
                        id : self.$route.params.id
                    }
                };
                HTTP.get('/par/request/get', config)
                    .then(response => {
                        if(response.data.code == 200) {
                            self.returnOrder = response.data.content.return_order;
                            self.creditPO = response.data.content.credit_po;
                            self.claim = response.data.content.claim;
                            self.by = response.data.content.by_par;
                            self.date = response.data.content.date;
                            self.parTag = response.data.content.par_tag;
                            self.po = response.data.content.po;
                            self.daimlerInvoice = response.data.content.daimler_invoice;
                            self.customerInvoiceCredit = response.data.content.customer_invoice_credit;
                            self.restockingFee = response.data.content.restocking_fee;
                            self.location = {id: response.data.content.location, name: response.data.content.location, manager_email: response.data.content.return_order, manager_name: response.data.content.manager_name};
                            self.reasonForReturn = response.data.content.reason_for_return;
                            self.customerOrderError = response.data.content.customer_order_error;
                            self.boxedWrong = response.data.content.boxed_wrong;
                            self.damageAndPakageRelated = response.data.content.damage_pkg_related;
                            self.shipShort = response.data.content.ship_short;
                            self.defectNotDamage = response.data.content.defect_not_damage;
                            self.duplicateInvoice = response.data.content.duplicate_invoice;
                            self.returnToVendor = response.data.content.return_to_vendor;
                            self.freightAdjustmentAndClaim = response.data.content.freight_adjustment_claim;
                            self.wrongPartReceived = response.data.content.wrong_part_received;
                            self.billingAdjustment = response.data.content.billing_adjustment;
                            self.overage = response.data.content.overage;
                            self.incorrectDealerInvoiced = response.data.content.incorrect_dealer_invoiced;
                            self.shippedToWrongDealer = response.data.content.shipped_to_wrong_dealer;
                            self.specialAndLaborCharge = response.data.content.special_and_labor_charge;
                            self.freightClaims = response.data.content.freight_claims;
                            self.policyAdjustment = response.data.content.policy_adjustment;
                            self.corpReturnSupersededPart = response.data.content.corp_rtrn_superseded_part;
                            self.incorrectPrice = response.data.content.incorrect_price;
                            self.recallAndServiceReturn = response.data.content.recall_srvc_return;
                            self.dealerPARWarehouseLocation = response.data.content.dealer_par_warehouse_location;
                            self.other = response.data.content.other;
                            self.otherText = response.data.content.other_text;
                            self.partsArr = response.data.content.part;
                            self.plusCount = self.plusCount - (response.data.content.part.length - 1);
                            self.loadDocArr = response.data.content.document;
                            self.uploadManually();
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            loadLocation: function() {
                var config = {
                    params: {
                        slug: "velocity-vehicle-group",
                        department_id: 1
                    }
                };
                self.showLoader();
                HTTPGUZZLE.get("/getdepartmentlocationswohtml", config)
                        .then(function (response) {
                            self.location_arr = response.data.locations;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            self.catchHandler(err, function () {});
                        });
            },
            removePartDocument: function(object, index) {
                if(self.plusCount <= 4 ) {
                    self.plusCount = self.plusCount + 1;
                    self.partsArr.splice(index, 1);
                }
            },
            addNewDocument: function (object, index) {
                var error = true;
                self.partsArr[index].partError = "";
                self.partsArr[index].quantityError = "";
                self.partsArr[index].descriptionError = "";

                if(!self.partsArr[index].part) {
                    self.partsArr[index].partError = "Enter Part";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.partsArr[index].quantity) {
                    self.partsArr[index].quantityError = "Enter Quantity";
                    if (error) {
                        error = false;
                    }
                } else if(self.partsArr[index].quantity && !self.numberFormateValidation(self.partsArr[index].quantity)) {
                    self.partsArr[index].quantityError = "Only Numeric Value Allow";
                    if (error) {
                        error = false;
                    }
                } else if (self.partsArr[index].quantity && self.numberFormateValidation(self.partsArr[index].quantity) && self.partsArr[index].quantity > 1000) {
                    self.partsArr[index].quantityError = "Max Quantity is 1000";
                    if (error) {
                        error = false;
                    }
                } else if (self.partsArr[index].quantity && self.numberFormateValidation(self.partsArr[index].quantity) && self.partsArr[index].quantity <= 0) {
                    self.partsArr[index].quantityError = "Please enter valid Qty";
                    if (error) {
                        error = false;
                    }
                }
                if(!self.partsArr[index].description) {
                    self.partsArr[index].descriptionError = "Enter Description";
                    if (error) {
                        error = false;
                    }
                }
                if(error) {
                    self.plusCount = self.plusCount - 1;
                    self.partsArr.push(Vue.util.extend({}, self.tempObject))
                }
            },
            checkForm: function () {
                var checked = true;
                self.returnOrderError = "";
                self.creditPOError = "";
                self.claimError = "";
                self.byError = "";
                self.dateError = "";
                self.parTagError = "";
                self.poError = "";
                self.daimlerInvoiceError = "";
                self.customerInvoiceCreditError = "";
                self.restockingFeeError = "";
                self.locationError = "";
                self.otherTextError = "";
                self.partsArr[0].partError = "";
                self.partsArr[0].quantityError = "";
                self.partsArr[0].descriptionError = "";
                self.reasonForReturnError = "";

                /* // if(self.loginUserRoleId == 1 || self.loginUserRoleId == 2) {
                if(self.loginUserRoleId == 1) {
                    if (!self.returnOrder) {
                        self.returnOrderError = "Enter Return Order";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (!self.creditPO) {
                        self.creditPOError = "Enter Credit PO";
                        if (checked) {
                            checked = false;
                        }
                    }
                    if (!self.claim) {
                        self.claimError = "Enter Claim";
                        if (checked) {
                            checked = false;
                        }
                    }
                } */
                if (!self.by) {
                    self.byError = "Enter By";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.date) {
                    self.dateError = "Select Date";
                    if (checked) {
                        checked = false;
                    }
                }
                /* if (!self.parTag) {
                    self.parTagError = "Enter PAR Tag";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.po) {
                    self.poError = "Enter PO";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.daimlerInvoice) {
                    self.daimlerInvoiceError = "Enter Daimler Invoice";
                    if (checked) {
                        checked = false;
                    }
                } */
                if(self.customerInvoiceCredit && !self.numberFormateValidation(self.customerInvoiceCredit)) {
                    self.customerInvoiceCreditError = "Only Numeric Value Allow";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.restockingFee && !self.numberFormateValidation(self.restockingFee)) {
                    self.restockingFeeError = "Only Numeric Value Allow";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.location == null || !self.location.id) {
                    self.locationError = "select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.reasonForReturn) {
                    self.reasonForReturnError = "Enter Reason for Return";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.partsArr[0].part) {
                    self.partsArr[0].partError = "Enter Part";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.partsArr[0].quantity) {
                    self.partsArr[0].quantityError = "Enter Quantity";
                    if (checked) {
                        checked = false;
                    }
                } else if(self.partsArr[0].quantity && !self.numberFormateValidation(self.partsArr[0].quantity)) {
                    self.partsArr[0].quantityError = "Only Numeric Value Allow";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.partsArr[0].quantity && self.numberFormateValidation(self.partsArr[0].quantity) && self.partsArr[0].quantity > 1000) {
                    self.partsArr[0].quantityError = "Max Quantity is 1000";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.partsArr[0].quantity && self.numberFormateValidation(self.partsArr[0].quantity) && self.partsArr[0].quantity <= 0) {
                    self.partsArr[0].quantityError = "Please enter valid Qty";
                    if (checked) {
                        checked = false;
                    }
                }
                if(!self.partsArr[0].description) {
                    self.partsArr[0].descriptionError = "Enter description";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.imagesPaths.length === 0)  {
                    self.fileUploadError = "Please upload file";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.other) {
                    if (!self.otherText) {
                        self.otherTextError = "Enter Other Text";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                return checked;
            },
            addPARRequest(flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                        };
                        var fields = {
                            id: self.edit_id,
                            manager_email: self.managerEmail,
                            manager_name: self.managerName,
                            return_order: self.returnOrder,
                            credit_po: self.creditPO,
                            claim: self.claim,
                            by: self.by,
                            date: self.date,
                            par_tag: self.parTag,
                            po: self.po,
                            daimler_invoice: self.daimlerInvoice,
                            customer_invoice_credit: self.customerInvoiceCredit,
                            restocking_fee: self.restockingFee,
                            location: self.location.name,
                            parts_mapper: self.partsArr,
                            reason_for_return: self.reasonForReturn,
                            customer_order_error: self.customerOrderError,
                            boxed_wrong: self.boxedWrong,
                            damage_and_pakage_related: self.damageAndPakageRelated,
                            ship_short: self.shipShort,
                            defect_not_damage: self.defectNotDamage,
                            duplicate_invoice: self.duplicateInvoice,
                            return_to_vendor: self.returnToVendor,
                            freight_adjustment_and_claim: self.freightAdjustmentAndClaim,
                            wrong_part_received: self.wrongPartReceived,
                            billing_adjustment: self.billingAdjustment,
                            overage: self.overage,
                            incorrect_dealer_invoiced: self.incorrectDealerInvoiced,
                            shipped_to_wrong_dealer: self.shippedToWrongDealer,
                            special_and_labor_charge: self.specialAndLaborCharge,
                            freight_claims: self.freightClaims,
                            policy_adjustment: self.policyAdjustment,
                            corp_return_superseded_part: self.corpReturnSupersededPart,
                            incorrect_price: self.incorrectPrice,
                            recall_and_service_return: self.recallAndServiceReturn,
                            dealer_par_warehouse_location: self.dealerPARWarehouseLocation,
                            other: self.other,
                            other_text: self.other ? self.otherText : '',
                            images_type: self.imagesType,
                            images_size: self.imagesSize,
                            images_paths: self.imagesPaths,
                        };
                        self.showLoader();
                        HTTP.post("/par/request/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.showSAlert(response.data.message, 'success');
                                    /* if(self.loginUserRoleId == 1 || self.loginUserRoleId == 2) {
                                        self.buttonBack();
                                    } else {
                                        self.clearAllInputs();
                                    } */
                                    self.buttonBack();
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.hideLoader();
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            clearAllInputs: function() {
                self.edit_id = 0;
                self.managerEmail = '';
                self.managerName = '';
                self.returnOrder = '';
                self.creditPO = '';
                self.claim = '';
                self.by = '';
                self.date = '';
                self.parTag = "";
                self.po = "";
                self.daimlerInvoice = "";
                self.customerInvoiceCredit = "";
                self.restockingFee = "";
                self.location = "";
                self.partsArr = [
                    {
                        part: "",
                        partError: "",
                        quantity: "",
                        quantityError: "",
                        description: "",
                        descriptionError: "",
                    },
                ];
                self.plusCount = 4;
                self.reasonForReturn = "";
                self.customerOrderError = 0;
                self.boxedWrong = 0;
                self.damageAndPakageRelated = 0;
                self.shipShort = 0;
                self.defectNotDamage = 0;
                self.duplicateInvoice = 0;
                self.returnToVendor = 0;
                self.freightAdjustmentAndClaim = 0;
                self.wrongPartReceived = 0;
                self.billingAdjustment = 0;
                self.overage = 0;
                self.incorrectDealerInvoiced = 0;
                self.shippedToWrongDealer = 0;
                self.specialAndLaborCharge = 0;
                self.freightClaims = 0;
                self.policyAdjustment = 0;
                self.corpReturnSupersededPart = 0;
                self.incorrectPrice = 0;
                self.recallAndServiceReturn = 0;
                self.dealerPARWarehouseLocation = 0;
                self.other = 0;
                self.otherText = "";
                self.imagesType = [];
                self.imagesSize = [];
                self.imagesPaths = [];
                self.imageWidth = 0;
                self.imageHeight = 0;
                self.isFileUploaded = false;
                self.fileUploadError = "";
                self.loadDocArr = [];
                self.removeAllFiles();
            },
            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
                self.isFileUploaded = false;
            },
            uploadDocument: function (file, response) {
                var self = this;
                self.fileUploadError = '';
                $("#savePARRequest, #cancelPARRequest").prop('disabled', false);
                self.imagesPaths.push(response.content);
                self.imagesType.push(file.type);
                self.imagesSize.push(file.size);
                // this.$refs.dropzone.setOption('maxFiles', null);
            },
            removedSelectedFile(file, xhr, error) {
                var self = this;
                $("#savePARRequest, #cancelPARRequest").prop('disabled', false);
                
                // this.$refs.dropzone.setOption('maxFiles', null);
                var removeFile = "";
                if (this.$refs.dropzone.dropzone.options.maxFiles) {
                    // this.$refs.dropzone.setOption('maxFiles', null);
                }
                if ("manuallyAdded" in file == true) {
                    for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                        if (self.imagesPaths[i].indexOf(file.name) != -1) {
                            removeFile = self.imagesPaths[i];
                        }
                    }
                    // this.$refs.dropzone.setOption('maxFiles', null);
                } else {
                    if(file.xhr == undefined) {
                        return  false;
                    }
                    var filePath = JSON.parse(file.xhr.response);
                    removeFile = filePath.content;
                    self.removeFileFromServer(removeFile);
                    removeFile = removeFile.media_path
                }
                for (var i = self.imagesPaths.length - 1; i >= 0; i--) {
                    if (self.imagesPaths[i] === removeFile) {
                        self.imagesPaths.splice(i, 1);
                        self.imagesType.splice(i, 1);
                        self.imagesSize.splice(i, 1);
                        //break;       //<-- Uncomment  if only the first term has to be removed
                    }
                }
                // this.$refs.dropzone.setOption('maxFiles', null);
            },
            removeFileFromServer: function (filePath) {
                var self = this;
                //console.log(filePath);return false;
                var config = {
                    headers: {"Authorization": "Bearer " + localStorage.getItem("tkn")},
                    data: {
                        filePath: filePath,
                    }
                };
                // self.showLoader();
                HTTP.delete('removemedia', config)
                    .then(function (response) {
                        // self.hideLoader();
                    })
                    .catch(function (err) {
                        // self.hideLoader();
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                self.$router.push("/");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            fileError: function (file, xhr, error) {
                if(xhr.code == 400) {
                    self.showSAlert(xhr.message, 'error', false);
                }
            },
            fileAdd: function (file, xhr, error) {
                $("#savePARRequest, #cancelPARRequest").prop('disabled', true);
                if (this.$refs.dropzone.dropzone.options.maxFiles) {
                    // this.$refs.dropzone.setOption('maxFiles', null);
                }
            },
            progressOfUloadBanner(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    $("#savePARRequest, #cancelPARRequest").prop('disabled', false);
                } else {
                    $("#savePARRequest, #cancelPARRequest").prop('disabled', true);
                }
            },
            uploadManually() {
                var self = this;
                if(self.loadDocArr.length > 0){
                    for (var i = 0; i < self.loadDocArr.length; i++) {
                        if (self.loadDocArr[i]['media_from'] == 'media_url') {
                            var mockFile = {name: "image_" + i + ".jpg", size: self.loadDocArr[i]['size']};
                            let imgUrl = self.loadDocArr[i]['thumb_url'];
                            let imageName = imgUrl.split("https://www.imanpro.net/pub/co/sac/photo/");
                            this.$refs.dropzone.dropzone.options.addedfile.call(this.$refs.dropzone.dropzone, mockFile);
                            this.$refs.dropzone.dropzone.options.thumbnail.call(this.$refs.dropzone.dropzone, mockFile, imgUrl);
                        } else {
                            var url = self.loadDocArr[i]['media_path'];
                            var file_name = self.getFileName(self.loadDocArr[i]['media_path']);
                            var file_type = self.loadDocArr[i]['type'];
                            var file_size = self.loadDocArr[i]['size'];
                            self.imagesType.push(file_type);
                            self.imagesSize.push(Number(file_size));
                            var file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                            self.$refs.dropzone.manuallyAddFile(file_data, url);
                        }
                    }
                }
                $("#savePARRequest, #cancelPARRequest").prop('disabled', false);
            },
            getFileName: function (file) {
                var self = this;
                var src = file.split('/');
                var file_name = src[src.length - 1];
                var orgPath = src[src.length - 2];
                self.imagesPaths.push(String(orgPath + "/" + file_name));
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            numberFormateValidation : function (inputtxt) {
                var valid = !/^\s*$/.test(inputtxt) && !isNaN(inputtxt);
                return valid;
            },
        }
    };
</script>
<style scoped>
    .block-title-par-request {
        float: left;
        width: 100%;
        margin: 0 0 15px 0;
        padding: 0;
        font-weight: normal;
        font-size: 28px;
        color: #0f467c;
        font-family: 'SanFranciscoDisplay-Bold';
    }
    .requied-par-request {
        position: relative;
        padding-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Forms/PARRequest/AddUpdatePARRequest.vue